var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-back"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('ArrowIcon',{staticClass:"arrow",attrs:{"color":"#000"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }